<div class="notification-box" (click)="toggleNotificationMobile()">
	<svg>
		<use href="assets/svg/icon-sprite.svg#notification"></use>
	</svg>
	<span class="badge rounded-pill badge-secondary">{{ notifications?.length }}</span>
</div>

<div class="notification-dropdown" [class.show]="openNotification">
	<h6 class="f-18 mb-0 dropdown-title">Notifications</h6>
	<ul class="scroll-demo">
		<li class="b-l-secondary border-4" *ngFor="let notification of notifications">
			<p>{{ notification?.project?.name }}</p>
			<p class="font-secondary">
				{{ notification?.product?.name }}
				<span class="font-secondary">
					{{ notification?.qte }}
					<span class="text-dark">in stock</span>
				</span>
			</p>
		</li>
	</ul>
</div>
